var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-test":"ContactForm"}},[_c('h6',{staticClass:"mb-4"},[_vm._v("Contatti")]),(_vm.show)?_c('v-form-base',{attrs:{"schema":_vm.schema,"model":_vm.model}}):_vm._e(),_vm._v(" "+_vm._s(_vm.type)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }